import { genericRequest } from 'app/api/genericRequest';

/**
 * @param {array} ids
 * @param {string} mediaType
 * @param {array} languages
 */

export const getMediaZipFiles = async (
  ids,
  mediaType,
  languages = [],
  countries = []
) => {
  try {
    const request = await genericRequest({
      url: 'media-download-request',
      method: 'POST',
      data: {
        data: {
          type: 'media-download-request',
          attributes: {
            ids,
            languages,
            countryIsoCodes: countries,
            mediaType
          }
        }
      }
    });
    return request;
  } catch (error) {
    return error;
  }
};
